// extracted by mini-css-extract-plugin
var _1 = "ihjjQ";
var _2 = "wMAFB";
var _3 = "GBDRA";
var _4 = "dxoBY";
export { _1 as "blackButton", _2 as "buttonTextWrapper", _3 as "following", _4 as "inner" }
